import { Sortbar } from '@ffw/randstad-shared-components/build';
import UI from '@UI/hoc/UI';
import WithLib from '@UI/hoc/WithLib';

export default WithLib(['untouched'])(UI(Sortbar)());
